import { Button } from "@omni/ui/components/Button/button.component";
import { MouseEventHandler } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

type AddToCardModalFooterProps = {
    onModalClose?: MouseEventHandler<HTMLButtonElement>;
};

const AddToCardModalFooter = ({ onModalClose }: AddToCardModalFooterProps) => {
    const { t } = useGranite();

    const handleOnConfirmClick = () => {
        location.replace(Config.pages.cart);
    };

    const handleOnCloseClick: MouseEventHandler<HTMLButtonElement> = (
        event
    ) => {
        onModalClose?.(event);
    };

    return (
        <div className="container p-0 m-0 pt-3">
            <div className="row align-items-center">
                <div className="col-5 col-lg-8">
                    <Button
                        color={"link"}
                        data-test="addToCartModal-link-cancel"
                        className="text-break"
                        onClick={handleOnCloseClick}
                    >
                        <i className="las la-angle-left" />
                        {t("product.addtocart.modal.cancel")}
                    </Button>
                </div>
                <div className="col-7 col-lg-4">
                    <button
                        type={"button"}
                        data-test="addToCartModal-button-confirm"
                        className="btn btn-secondary w-100"
                        style={{ wordBreak: "break-word" }}
                        onClick={handleOnConfirmClick}
                    >
                        {t("product.addtocart.modal.confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export { AddToCardModalFooter };
